import { Skeleton } from '@lego/connect-components-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';

type TableSkeletonProps = {
  columns: number;
  page?: boolean;
  showAction?: boolean;
};

export const TableSkeleton = ({
  columns,
  page = false,
  showAction = false,
}: TableSkeletonProps) => {
  const { t } = useTranslation();
  const columnKeys = Array.from({ length: columns }, (_, index) => `column-${index}`);

  return (
    <div
      className={cn(page && 'px-400 py-400')}
      role="status"
      aria-label={t('formPrintPage.loading', 'Loading...')}
    >
      {page && (
        <div className="mb-300 flex items-center justify-between">
          <Skeleton width="12rem" height="2rem" showAnimation />
          {showAction && <Skeleton width="8rem" height="2rem" showAnimation />}
        </div>
      )}
      <div className="mb-300 max-w-md">
        <Skeleton height="2.5rem" showAnimation />
      </div>
      <div className="flex gap-200" aria-hidden="true">
        {columnKeys.map((column) => (
          <div key={column} data-testid="skeleton-column" className="min-w-0 flex-1">
            <Skeleton height="1rem" showAnimation />
            <div className="mt-200">
              <Skeleton rows={5} rowSize="large" showAnimation />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
